import api from '@tyrio/api-factory';
import { DBServicesApi } from '@tyrio/dto';
import { useQuery } from 'react-query';

export const useGetServiceById = (id: string, loadData: boolean) => {
  const { data, refetch } = useQuery(
    ['get_service_by_id', id],
    () =>
      api.fetch<DBServicesApi['getOne']>(`get_service_by_id`, {
        id,
      }),
    {
      enabled: !!id && loadData,
    }
  );
  return { data, refetch };
};
